<style lang="less">
@import '~@/assets/styles/_var.less';

.main {
  //min-width: 1080px;
  //smax-width: 1820px;
  // margin: 20px auto;
}
.el-button--primary {
  background-color: @color-primary;
  border-color: @color-primary;
}
.el-link.el-link--primary {
  color: @color-primary !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: @color-primary !important;
}
/deep/.el-notification__group {
  width: 100%;
  .el-notification__content {
    width: calc(100% - 50px);
    p {
      word-wrap: break-word;
    }
  }
}
</style>

<template>
  <div>
    <page-header></page-header>
    <router-view class="main" />
    <page-footer v-if="r !== '/' && r !== '/challenge'"></page-footer>
  </div>
</template>

<script>
import PageHeader from '@/components/Header';
import PageFooter from '@/components/Footer';

export default {
  components: {
    PageHeader,
    PageFooter,
  },
  data() {
    return {
      r: this.$route.path,
    };
  },
  watch: {
    $route(to) {
      this.r = to.path;
    },
  },
};
</script>
